import React, { useState } from 'react';
import { Scissors, Hand, Flower2, Leaf, Sparkles, ChevronRight } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Sparkles: Sparkles,
  Scissors: Scissors,
  Hand: Hand,
  Flower2: Flower2,
  Leaf: Leaf,
};

export const ServicesSection = () => {
  const [activeCategory, setActiveCategory] = useState(services[0].category);

  const activeServices = services.find(s => s.category === activeCategory);

  const scrollToBooking = () => {
    const element = document.querySelector('#booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="relative overflow-hidden bg-neutral-50 py-24">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#d4af37]/5 via-transparent to-transparent" />
      
      {/* Gold accent lines */}
      <div className="absolute right-0 top-1/4 h-px w-48 bg-gradient-to-l from-transparent to-[#d4af37]/30" />
      <div className="absolute left-0 bottom-1/4 h-px w-48 bg-gradient-to-r from-transparent to-[#d4af37]/30" />
      
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-[#d4af37]/10 px-4 py-1.5 text-sm font-medium text-[#d4af37] border border-[#d4af37]/20">
            <Sparkles className="h-4 w-4" />
            Nuestros Servicios
          </div>
          <h2 className="font-serif text-3xl font-bold text-neutral-800 sm:text-4xl lg:text-5xl">
            Experiencias de belleza únicas
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-neutral-600">
            Descubre nuestra amplia gama de tratamientos diseñados para realzar tu belleza natural
          </p>
        </div>

        {/* Category Tabs */}
        <div className="mt-12 flex flex-wrap justify-center gap-3">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            const isActive = activeCategory === service.category;
            
            return (
              <button
                key={service.category}
                onClick={() => setActiveCategory(service.category)}
                className={`flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium transition-all duration-300 ${
                  isActive
                    ? 'bg-neutral-900 text-[#d4af37] shadow-lg'
                    : 'bg-white text-neutral-600 border border-neutral-200 hover:border-[#d4af37]/50 hover:text-[#d4af37]'
                }`}
              >
                {IconComponent && <IconComponent className="h-4 w-4" />}
                <span className="hidden sm:inline">{service.category}</span>
              </button>
            );
          })}
        </div>

        {/* Active Category Title */}
        <div className="mt-8 text-center">
          <h3 className="inline-flex items-center gap-3 text-2xl font-semibold text-neutral-800">
            {(() => {
              const IconComponent = iconMap[activeServices?.icon];
              return IconComponent ? <IconComponent className="h-6 w-6 text-[#d4af37]" /> : null;
            })()}
            {activeCategory}
          </h3>
        </div>

        {/* Services Grid */}
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {activeServices?.items.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl bg-white p-6 transition-all duration-300 hover:shadow-xl border border-neutral-200 hover:border-[#d4af37]/30"
            >
              {/* Decorative corner */}
              <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[#d4af37]/5 transition-transform duration-300 group-hover:scale-150" />
              
              <div className="relative">
                <h4 className="text-lg font-semibold text-neutral-800">
                  {item.name}
                </h4>
                <p className="mt-2 text-sm text-neutral-600">
                  {item.description}
                </p>
                <div className="mt-4 inline-flex items-center gap-1 rounded-full bg-[#d4af37]/10 px-3 py-1 text-xs font-medium text-[#d4af37] border border-[#d4af37]/20">
                  <Sparkles className="h-3 w-3" />
                  {item.benefit}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <button
            onClick={scrollToBooking}
            className="group inline-flex items-center gap-2 rounded-full bg-neutral-900 px-8 py-4 text-lg font-semibold text-white shadow-lg transition-all duration-300 hover:bg-neutral-800 hover:shadow-xl"
          >
            <span className="text-[#d4af37]">Reserva tu experiencia</span>
            <ChevronRight className="h-5 w-5 text-[#d4af37] transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
};
